/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { SelectInput } from '@blend/consumer-components';

import { InputWrapperProps } from '../../../TaskInputs/types';
import { stateCodes } from '../constants';

const StateInput = ({ config, input, meta, ...htmlProps }: InputWrapperProps) => (
  <SelectInput {...htmlProps} {...input} choices={stateCodes.states} />
);

export default StateInput;
